module.exports = __webpack_public_path__ + "img/20190713125214YY截图20190712232804.6ff2d4f9.png";